import React from 'react';
import MultiItemUpDown from './MultiItemUpDown';

/**
 * @typedef {object} ProgramYearFilterProps
 * @property {Array<*>} [programYearOptions]
 * @property {string} [additionalClassNames]
 * @property {(selectedKey: string | number) => void} [handleOnChange]
 * @property {number} [selectedAppraisalId]
 * @property {boolean} loading
 */

/**
 * @param {ProgramYearFilterProps} props
 */
const ProgramYearFilter = props => {
  const {
    programYearOptions = [],
    selectedAppraisalId,
    handleOnChange,
    additionalClassNames = '',
    loading
  } = props;

  return (
    <MultiItemUpDown
      className={additionalClassNames}
      disabled={programYearOptions.length === 0}
      options={programYearOptions}
      value={selectedAppraisalId || ''}
      setValue={handleOnChange}
      selectId='selected-program-year'
      upDownId='select-program-year'
      loading={loading}
    />
  );
};

export default ProgramYearFilter;
